import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';

import PageContentLayout from '@ts-core/core/components/PageContentLayout';
import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';
import StudentActivitiesList from '@ts-core/modules/activities/components/StudentActivitiesList';
import { StudentActivity } from '@ts-core/modules/activities/types';

import { useActivities } from '../../hooks';

const ActivitiesPage = () => {
  const history = useHistory();
  const { courseId } = useParams<{ courseId: string }>();
  const { activeActivities, expiredActivities, loading } = useActivities({ courseId });

  const handleActivityActionClick = useCallback(
    (activity: StudentActivity) => {
      history.push(`/${courseId}/activities/${activity.id}`);
    },
    [history, courseId]
  );

  return (
    <div>
      <ToMainMenuButton title="Tareas" />
      <PageContentLayout>
        {(activeActivities?.length || 0) > 0 && (
          <Box>
            <Typography ml={2} loading={loading} fontWeight={700} variant="body2">
              Tareas Activas
            </Typography>
            <StudentActivitiesList activities={activeActivities} loading={loading} sx={{ mt: 1 }} onActivityActionClick={handleActivityActionClick} />
          </Box>
        )}
        {(expiredActivities?.length || 0) > 0 && (
          <Box>
            <Typography ml={2} loading={loading} fontWeight={700} variant="body2" mt={4}>
              Tareas Pasadas
            </Typography>
            <StudentActivitiesList
              activities={expiredActivities}
              loading={loading}
              sx={{ mt: 1 }}
              onActivityActionClick={handleActivityActionClick}
            />
          </Box>
        )}
      </PageContentLayout>
    </div>
  );
};

export default ActivitiesPage;
